import styled from "@mui/material/styles/styled";
import { IconButton } from "@mui/material";
import { CSSProperties } from "react";

export const PATIENT_CARD_HEADER_DESKTOP_HEIGHT = 128.5;

export const PatientCardSummaryAction = styled(IconButton)({
  background: "#E6E4FF",
  fontWeight: "bold",
  textTransform: "capitalize",
  color: "#5A52C3",
  "&:not(.no-background)": {
    minWidth: "auto",
  },
  "&.no-background": {
    background: "transparent",
  },
  "& svg": {
    width: "12px",
    height: "12px",
  },
  padding: "8px",
});

export const onAddonAndThemeBreakPoint = (
  breakpointString: string,
  css: CSSProperties,
) => ({
  [breakpointString]: {
    ...css,
  },
  ".addon &": {
    ...css,
  },
});
